<template>
    <div>
        <h1>Halogenkohlenwasserstoffe</h1>
        <p>
            Wird bei einem Kohlenwasserstoff mindestens ein Wasserstoffatom
            durch ein Halogen substituiert, so wird es zu einem
            Halogenkohlenwassertstoff.
        </p>
        <chapter-heading title="Halogenalkane"></chapter-heading>
        <p>
            Halogenalkane entstehen durch die
            <router-link to="/reaktionen-nachweise/radikalische-substitution"
                >radikalische Substitution</router-link
            >
            eines Alkans.
            <br />
            Halogenalkane eignen sich sehr gut als Lösungsmittel für
            nicht-wasserlösliche Stoffe, aber auch zur Entfettung von
            Metalloberflächen.
        </p>
        <hr class="chapter-split" />
        <chapter-heading title="Halogenalkene"></chapter-heading>
        <p>
            Wird ein Wasserstoffatom durch ein Halogen in einem Alken mittels
            einer
            <router-link to="/reaktionen-nachweise/elektrophile-substitution"
                >Elektrophile Substitution</router-link
            >, entsteht ein Halogenalken.
        </p>
        <hr class="chapter-split" />
        <chapter-heading title="Halogenaromaten"></chapter-heading>
        <p>
            Ist ein Halogenkohlenwasserstoff eine aromatische Verbindung, nach
            der Hückel-Regel, so gehört es zu den Halogenaromaten.
        </p>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
